import Employee from '@/components/_templates/employee/Index.vue';
import EmployeeProfile from '@/components/_templates/employee/profile/Profile.vue';

import EmployeeResume from '@/components/_templates/employee/resume/Resume.vue';
import EmployeeResumeList from '@/components/_templates/employee/resume/List.vue';
import EmployeeResumeEditJob from '@/components/_templates/employee/resume/EditJob.vue';
import EmployeeResumeEditEducation from '@/components/_templates/employee/resume/EditEducation.vue';
import EmployeeResumeEditLanguage from '@/components/_templates/employee/resume/EditLanguage.vue';
import EmployeeResumeEditCertification from '@/components/_templates/employee/resume/EditCertification.vue';

import EmployeeFavorite from '@/components/_templates/employee/favorite/Favorite.vue';

import EmployeeApplication from '@/components/_templates/employee/application/Application.vue';
import EmployeeApplicationList from '@/components/_templates/employee/application/ApplicationList.vue';
import EmployeeApplicationDatatable from '@/components/_templates/employee/application/ApplicationDatatable.vue';
import EmployeeApplicationEdit from '@/components/_templates/employee/application/edit/ApplicationEdit.vue';

import EmployeeCooperationAgreements from '@/components/_templates/employee/cooperation-agreement/CooperationAgreement.vue';

const employeeRoutes = [
  {
    path: '/employee',
    name: 'employee',
    component: Employee,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'profile',
        name: 'employee.profile',
        component: EmployeeProfile,
        meta: { requiresAuth: true },
      },
      {
        path: 'resume',
        name: 'employee.resume',
        component: EmployeeResume,
        meta: { requiresAuth: true },
        redirect: { name: 'employee.resume.list' },
        children: [
          {
            path: '',
            name: 'employee.resume.list',
            component: EmployeeResumeList,
            meta: { requiresAuth: true },
          },
          {
            path: 'job/:id?',
            name: 'employee.resume.job',
            component: EmployeeResumeEditJob,
            meta: { requiresAuth: true, resumeType: 'jobs' },
          },
          {
            path: 'education/:id?',
            name: 'employee.resume.education',
            component: EmployeeResumeEditEducation,
            meta: { requiresAuth: true, resumeType: 'educations' },
          },
          {
            path: 'language/:id?',
            name: 'employee.resume.language',
            component: EmployeeResumeEditLanguage,
            meta: { requiresAuth: true, resumeType: 'languages' },
          },
          {
            path: 'certification/:id?',
            name: 'employee.resume.certification',
            component: EmployeeResumeEditCertification,
            meta: { requiresAuth: true, resumeType: 'certifications' },
          },
        ],
      },
      {
        path: 'favorite',
        name: 'employee.favorite',
        component: EmployeeFavorite,
        meta: { requiresAuth: true },
      },
      {
        path: 'application',
        name: 'employee.application',
        component: EmployeeApplication,
        redirect: { name: 'employee.application.list' },
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'employee.application.list',
            component: EmployeeApplicationList,
            meta: { requiresAuth: true },
            redirect: { name: 'employee.application.list.all' },
            children: [
              {
                path: '',
                name: 'employee.application.list.all',
                component: EmployeeApplicationDatatable,
                meta: { requiresAuth: true, listType: 'all' },
              },
              {
                path: 'open',
                name: 'employee.application.list.open',
                component: EmployeeApplicationDatatable,
                meta: { requiresAuth: true, listType: 'open' },
              },
              {
                path: 'draft',
                name: 'employee.application.list.draft',
                component: EmployeeApplicationDatatable,
                meta: { requiresAuth: true, listType: 'draft' },
              },
              {
                path: 'completed',
                name: 'employee.application.list.completed',
                component: EmployeeApplicationDatatable,
                meta: { requiresAuth: true, listType: 'closed' },
              },
            ],
          },
          {
            path: 'edit/:id?',
            name: 'employee.application.edit',
            component: EmployeeApplicationEdit,
            meta: { requiresAuth: true },
          },
        ],
      },
      {
        path: 'cooperation-agreements',
        name: 'employee.cooperation-agreements',
        component: EmployeeCooperationAgreements,
        meta: { requiresAuth: true },
      },
    ],
  },
];

export default employeeRoutes;
